var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('headful',{attrs:{"title":"Logout"}}),_c('v-card',{staticStyle:{"max-width":"440px","margin":"auto"}},[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('h1',{staticStyle:{"color":"white","margin":"auto"}},[_vm._v("Logging Out")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }